import React, { Component } from 'react';
import { observer } from 'mobx-react';

import LabelSelector from 'app/components/labels/LabelSelector';
import { Box, Flex, Heading } from 'core/components';
import { Field, FormComponent, InputGroup, ShareLevelSelector, Switch, TextArea } from 'core/form';
import $auth from 'app/stores/$auth';
import SudoTag from 'app/components/SudoTag';

const boardFields = {
  title: {
    label: 'Title',
    required: true,
    defaultValue: ''
  },
  share_level: {
    label: 'Visibility',
    rules: 'required'
  },
  'config.description': {
    label: 'Description',
    defaultValue: ''
  },
  'config.syncTooltips': {
    label: 'Sync tooltips',
    helpText: 'Sync chart tooltips across all panels',
    defaultValue: false
  },
  'config.labels': {
    label: 'Labels',
    defaultValue: ''
  }
};

@observer
class BoardSettings extends Component {
  handleFormChange = ({ formValues }) => {
    const { board } = this.props;
    // Let's not lose all the bits of config that weren't actually in this form!
    const config = { ...board.get('config'), ...formValues.config };
    board.safeSet({ ...formValues, config });
  };

  render() {
    const { board } = this.props;

    return (
      <FormComponent
        fields={boardFields}
        model={board}
        options={{ name: 'board-form' }}
        onChange={this.handleFormChange}
      >
        {({ form }) => (
          <Flex flexDirection="column" gap={2} py={3} px={2} width={500} height="100%">
            <Heading level={4}>Settings</Heading>
            <Box>
              <Flex flexDirection="column" gap={2}>
                <Field name="title" large m={0}>
                  <InputGroup />
                </Field>
                <Field name="config.description" large m={0}>
                  <TextArea fill rows={2} />
                </Field>
                <LabelSelector useDialog m={0} />
                <ShareLevelSelector
                  field={form.getField('share_level')}
                  privateValue="self"
                  sharedValue="org"
                  globalValue="org"
                />
                {$auth.isSudoer && (
                  <Field
                    name="config.syncTooltips"
                    m={0}
                    label={
                      <Flex alignItems="center" gap="6px">
                        Sync tooltips <SudoTag small />
                      </Flex>
                    }
                  >
                    <Switch />
                  </Field>
                )}
              </Flex>
            </Box>
          </Flex>
        )}
      </FormComponent>
    );
  }
}

export default BoardSettings;
